import { Icon16Chevron } from "@vkontakte/icons";
import s from "./style.module.scss";
import clsx from "clsx";
import { useAction, useAtom } from "@reatom/npm-react";
import { toggleModal } from "../../core/reatom/state/modal/modal";
import { Skeleton } from "@vkontakte/vkui";
import { orderDocumentsAtom } from "@/core/reatom/state/orders/orders";

export const Garanty = ({
  days,
  price,
  document,
  isLoadingAtom,
  isLoadingSummaryAtom,
}: {
  isLoadingAtom: boolean;
  isLoadingSummaryAtom: boolean;
  days?: number;
  price?: string | number;
  document?: boolean;
}) => {
  const handleToggleModal = useAction(toggleModal);
  const [documents] = useAtom(orderDocumentsAtom);

  return (
    <div className={s.wrapper}>
      {isLoadingAtom ? (
        <>
          <Skeleton margin={"2px 0 0 0"} height={30} />
          <div className={s.secondLine}>
            <Skeleton margin={"2px 0 0 0"} height={30} />
            <Skeleton margin={"2px 0 0 0"} height={30} />
          </div>
        </>
      ) : (
        <>
          {!document && (
            <div
              className={s.garanty}
              onClick={() => handleToggleModal("garanty")}
            >
              <div>
                <p className={s.title}>Гарантия</p>
                <p className={s.description}>
                  Вернем деньги, если что-то пойдет не так.
                </p>
              </div>

              <Icon16Chevron className={s.icon} />
            </div>
          )}
          <div className={s.secondLine}>
            <div className={clsx(s.garanty, s.column)}>
              <p className={s.description}>Срок выполнения</p>
              <p className={s.title}>{days} дней</p>
            </div>

            <div className={clsx(s.garanty, s.column)}>
              <p className={s.description}>Стоимость</p>
              <p className={s.title}>
                {isLoadingSummaryAtom ? <Skeleton height={14} /> : price + " ₽"}
              </p>
            </div>
          </div>
          {document && (
            <div className={s.documents}>
              <div
                className={s.garanty}
                onClick={() => handleToggleModal("garanty")}
              >
                <div>
                  <p className={s.title}>Гарантия</p>
                  <p className={s.description}>
                    Вернем деньги, если что-то пойдет не так.
                  </p>
                </div>

                <Icon16Chevron className={s.icon} />
              </div>
              {documents && documents?.items.length > 0 && (
                <div
                  className={s.garanty}
                  onClick={() => handleToggleModal("documents")}
                >
                  <div>
                    <p className={s.title}>Документы сделки</p>
                  </div>

                  <Icon16Chevron className={s.icon} />
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};
